import { connect } from 'react-redux';
import React, { createContext } from 'react';

export const CustomTextContext = createContext({});

function CustomTextProvider({ children, customText }) {
  return <CustomTextContext.Provider value={customText}>{children}</CustomTextContext.Provider>;
}

export const CustomTextConsumer = CustomTextContext.Consumer;

export const CustomTextProviderContainer = connect(state => {
  return { customText: state.configuration.customText };
})(CustomTextProvider);
